import React from "react";
import { useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import { pageRoutes } from "../../routes/pageRoutes";
import { useNavigate } from "react-router-dom";

const OurServices = ({ isHeader = true }) => {
  const navigate = useNavigate();
  const { serviceList } = useSelector((state) => state?.homeReducer);

  return (
    <section className="we-help-section ct_service_bg">
      <div className="container">
        {isHeader && (
          <div className="ct_section_title">
            <h2 className="section-title mb-4 text-center text-white">
              <strong>Our Services</strong>
            </h2>
          </div>
        )}
        <div className="row">
          {serviceList && serviceList?.length > 0 ? (
            serviceList?.map((service) => (
              <div className="col-md-4 mb-4" key={service?.id}>
                <div className="ct_service_card">
                  <figure>
                    <div className="ct_service_img">
                      <img
                        src={service?.service_image}
                        alt={service?.service_title}
                      />
                    </div>
                    <figcaption>
                      <h4>{service?.service_title}</h4>
                      <div className="ct_overflow_p">
                        <p>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: service?.service_description,
                            }}
                          />
                        </p>
                      </div>
                      <a
                        href={service?.link}
                        onClick={() => {
                          navigate(pageRoutes?.serviceDetail,{state:{id:service?.id}});
                        }}
                        className="ct_view_more_link ct_pointer_cursor"
                      >
                        View More <i className="fa-solid fa-arrow-right"></i>
                      </a>
                    </figcaption>
                  </figure>
                </div>
              </div>
            ))
          ) : (
            <NoRecord className="text-center text-white" />
          )}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
